module.exports = __webpack_public_path__ + "media/images/lig/flatlay-02-bfbdac6db82a6c3346d35bf8b087d293.png";